var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen w-full bg-taxiye-500 flex flex-col items-center justify-center"},[_c('h1',{staticClass:"text-6xl font-semibold text-taxiye-900"},[_vm._v("404")]),_c('p',[_vm._v("Bong! Page doesn't exist!")])])
}]

export { render, staticRenderFns }